export default __webpack_public_path__ + "static/media/profileImg.68e21abf.PNG";